const EXPIRATION_ENDPOINT = 'club/v1/forwarder/expiration';

export const signout = ({ club: { id: clubId } = {}, language } = {}) => {
  if (!clubId || !language) return;

  document.location.href = `${process.env.SERVICE_USER}/${EXPIRATION_ENDPOINT}?idClub=${clubId}&lang=${language}`;
};
